import { MapIcon } from '@heroicons/react/24/outline';
import type { PermissionLookup } from '../iamLookups';
import type { RouteDomainGroup } from './routeDomainGrouping';
import { AccessCard } from '../primitives/AccessCard';
import { RouteRow } from './RouteRow';

interface RouteDomainSectionProps {
    group: RouteDomainGroup;
    permissionLookup: PermissionLookup;
    open: boolean;
    onToggle: () => void;
}

// One card per API domain. No progress bar - exact "N routes"/"N open" reads
// better than a bar showing ~0% everywhere today. Collapsed by default.
export function RouteDomainSection({
    group,
    permissionLookup,
    open,
    onToggle
}: RouteDomainSectionProps) {
    const openCount = group.counts.open;
    return (
        <AccessCard
            icon={MapIcon}
            title={group.domain}
            count={`${group.routes.length} route${group.routes.length === 1 ? '' : 's'}`}
            noBodyPadding
            collapsible
            open={open}
            onToggle={onToggle}
            action={
                openCount > 0 ? (
                    <span className="text-[11px] font-semibold text-rose-600">
                        {openCount} open
                    </span>
                ) : undefined
            }
        >
            {group.routes.map((route) => (
                <RouteRow
                    key={`${route.method}-${route.path}`}
                    route={route}
                    permissionLookup={permissionLookup}
                />
            ))}
        </AccessCard>
    );
}
